import React from 'react';
import { Formik } from 'formik';
import moment from 'moment';
import { useParams } from 'react-router-dom';

import FormWrapper from '~FormWrapper';

import ApplianceMaintenanceForm from './ApplianceMaintenanceForm';

import { removeEmptyKeys, isPhoneNumberValid } from '../validations';
import { useOnSubmit } from '~hooks/useOnSubmit';
import { useOnEdit } from '~hooks/useOnEdit';

const initialValues = {
  additionalInfo: '',
  collectFeedback: true,
  idNotKnown: false,
  identificationNumber: null,
  infectionRisk: false,
  needsTransport: false,
  contactPhone: '',
  deviceClass: null,
  office: null,
  maintenanceUnit: null,
  deliveryTime: {
    scheduleType: 'NORMAALI',
    earliestTime: moment('08.00', 'hh.mm'),
    latestTime: moment('15.00', 'hh.mm'),
  },
  pickupSpace: null,
  attachmentInput: [],
};

const validate = values => {
  const errors = {};

  errors.contactPhone = isPhoneNumberValid(values.contactPhone);

  if (!values.additionalInfo) {
    errors.additionalInfo = 'Vaadittu';
  }

  if (!values.identificationNumber && !values.idNotKnown) {
    errors.identificationNumber = 'Vaadittu';
  }

  if (values.idNotKnown) {
    if (!values.deviceClass) {
      errors.deviceClass = 'Vaadittu';
    }
    // if (!values.office) {
    //   errors.office = 'Vaadittu';
    // }
    // if (!values.maintenanceUnit) {
    //   errors.maintenanceUnit = 'Vaadittu';
    // }
    if (!values.deviceLocation) {
      errors.deviceLocation = 'Vaadittu';
    }
  }

  if (values.needsTransport) {
    if (!values.pickupSpace) {
      errors.pickupSpace = 'Vaadittu';
    }
  }

  return removeEmptyKeys(errors);
};

const onSubmit =
  (edit, formId, orderId, onFormSubmit, onFormEdit) =>
  async (values, { setSubmitting }) => {
    setSubmitting(true);

    const method = edit ? onFormEdit : onFormSubmit;

    await method({
      fields: {
        ...values,
        // Use ? because these may be null
        identificationNumber: values.identificationNumber?.value,
        maintenanceUnit: values.maintenanceUnit?.value,
        scheduleType: values.deliveryTime.scheduleType,
        earliestTime: values.deliveryTime.earliestTime,
        latestTime: values.deliveryTime.latestTime,
        office: values.office?.value,
        deviceUnit: values.deviceUnit?.value,
        attachmentInput: values.attachmentInput.map(a => ({ id: a.id })),
      },
      formId,
      setSubmitting,
      orderId,
    });
  };

const ApplianceMaintenance = props => {
  const { formId, edit } = props;
  const { orderId } = useParams();

  const onFormSubmit = useOnSubmit();
  const onFormEdit = useOnEdit();

  return (
    <Formik
      initialValues={initialValues}
      validate={validate}
      onSubmit={onSubmit(edit, formId, orderId, onFormSubmit, onFormEdit)}
    >
      {formikProps => {
        const id = formikProps.values.identificationNumber?.value;
        const { idNotKnown } = formikProps.values;

        return (
          <FormWrapper
            {...props}
            title="Tilaa laitehuolto"
            formik={formikProps}
            hideSubmitButton={!(id || idNotKnown)}
            Component={ApplianceMaintenanceForm}
          />
        );
      }}
    </Formik>
  );
};

export default ApplianceMaintenance;
